export default function PDFPreview() {
  return (
    <div className="pdf-preview-card">
      <div className="panel-title">PDF Preview</div>
      <div className="pdf-preview-note">
        Placeholder preview pane. Connect your generated PDF endpoint when available.
      </div>
      <iframe
        title="pdf-preview"
        src="/preview/table.pdf"
        width="100%"
        height="280"
      />
    </div>
  );
}
